export const layouts = [
  {
    name: "phonePortrait",
    condition: shouldDisplayPhonePortrait,
    sizeRanges: [{ width: [320, 500], height: [350, 2000] }],
    classes: ["io-1o-Checkout-phonePortrait", "io-1o-Checkout-rightTray"],
    isFullscreen: true,
    isShadowHidden: true
  },
  {
    name: "rightTray",
    condition: shouldDisplayRightTray,
    sizeRanges: [{ width: [0, 50000], height: [0, 50000] }],
    classes: ["io-1o-Checkout-rightTray", "io-1o-Checkout-phonePortrait"],
    isFullscreen: true,
    isShadowHidden: true
  },
  {
    name: "landscapeWide",
    sizeRanges: [{ width: [970, 1000], height: [250, 250] }],
    classes: ["io-1o-Checkout-landscapeWide", "io-1o-Widgets-Wide"]
  },
  {
    name: "landscapeXL",
    sizeRanges: [{ width: [800, 850], height: [497, 497] }],
    classes: ["io-1o-Checkout-landscapeXL", "io-1o-Widgets-XL"]
  },
  {
    name: "landscapeL",
    sizeRanges: [{ width: [650, 720], height: [413, 420] }],
    classes: ["io-1o-Checkout-landscapeL", "io-1o-Widgets-L"]
  },
  {
    name: "landscapeM",
    sizeRanges: [{ width: [550, 620], height: [295, 403] }],
    classes: ["io-1o-Checkout-landscapeM", "io-1o-Widgets-M"]
  },
  {
    name: "landscapeS",
    sizeRanges: [{ width: [250, 430], height: [200, 430] }],
    classes: ["io-1o-Checkout-landscapeS", "io-1o-Widgets-S"]
  },
  {
    name: "halfPageBanner",
    sizeRanges: [
      { width: [300, 300], height: [600, 670] },
      { width: [310, 310], height: [610, 680] },
      { width: [320, 320], height: [620, 690] },
      { width: [330, 330], height: [630, 700] }
    ],
    classes: ["io-1o-Checkout-halfPageBanner", "io-1o-Widgets-M"]
  },
  {
    name: "skyscraper",
    sizeRanges: [
      { width: [160, 160], height: [600, 640] },
      { width: [170, 170], height: [610, 650] },
      { width: [180, 180], height: [620, 660] },
      { width: [190, 190], height: [630, 670] },
      { width: [200, 200], height: [640, 680] }
    ],
    classes: ["io-1o-Checkout-skyscraper", "io-1o-Widgets-M"]
  },
  {
    name: "verticalRectangle",
    sizeRanges: [
      { width: [240, 260], height: [370, 440] }
      // { width: [240, 260], height: [324, 324] }
    ],
    classes: ["io-1o-Checkout-verticalRectangle", "io-1o-Widgets-L"]
  },
  {
    name: "button",
    sizeRanges: [{ width: [100, 150], height: [32, 32] }],
    classes: ["io-1o-Checkout-button", "io-1o-Widgets-S"],
    isShadowHidden: true
  },
  {
    name: "button",
    sizeRanges: [{ width: [110, 165], height: [35, 35] }],
    classes: ["io-1o-Checkout-button", "io-1o-Widgets-M"],
    isShadowHidden: true
  },
  {
    name: "button",
    sizeRanges: [{ width: [120, 180], height: [40, 40] }],
    classes: ["io-1o-Checkout-button", "io-1o-Widgets-L"],
    isShadowHidden: true
  },
  {
    name: "button",
    sizeRanges: [{ width: [130, 195], height: [50, 50] }],
    classes: ["io-1o-Checkout-button", "io-1o-Widgets-XL"],
    isShadowHidden: true
  },
  {
    name: "unsupported",
    sizeRanges: [{ width: [0, 0], height: [0, 0] }],
    classes: ["io-1o-Checkout-unsupported"],
    isShadowHidden: true
  }
]

const themeDescriptor = {
  borderColor: { default: "rgba(0, 0, 0, .13)" },
  borderWidth: { options: [1, 0, 2, 3] },
  borderRadius: { options: [8, 0] },
  pageLock: true,
  preload: false,
  outerBackgroundColor: { default: "rgba(0, 0, 0, .6)" },
  hasShadow: { options: [true, false] },
  mode: { default: "inline" },
  homeButtonText: { default: "Buy now" },
  externalButtonBackground: { default: "#EEEEEE" },
  externalButtonColor: { default: "#333" },
  externalButtonShortText: { default: "Buy now" },
  externalButtonLongText: { default: "Shop on website" },
  buttonBackground: { default: "hsl(209, 83%, 59%)" },
  buttonColor: { default: "white" }
}

const responsiveLayouts = ["landscapeS", "rightTray"]

function shouldDisplayPhonePortrait(
  width,
  height,
  mode,
  isPopup,
  calculateFromFrameSize
) {
  if (calculateFromFrameSize) {
    return (
      window.innerHeight > window.innerWidth &&
      window.innerWidth === width &&
      window.innerWidth >= 320 &&
      window.innerWidth <= 500 &&
      isPopup
    )
  }
  return (
    window.screen.height > window.screen.width &&
    window.screen.width === width &&
    window.screen.width >= 320 &&
    window.screen.width <= 500 &&
    isPopup
  )
}

function shouldDisplayRightTray(
  width,
  height,
  mode,
  isPopup,
  calculateFromFrameSize
) {
  return mode === "rightTray"
}

export function getLayoutDataForFrame(
  width,
  height,
  mode,
  calculateFromFrameSize = false
) {
  const minimumPopupMargin = 10
  const margins = mode === "popup" ? minimumPopupMargin * 2 : 0
  let maxArea = -1
  let framedLayout
  let framedWidth
  let framedMaxWidth
  let framedHeight
  let framedMaxHeight
  let isPopup = mode === "popup" || mode === "fullframe"
  let isFullscreen = mode === "fullframe"
  for (let layout of layouts) {
    if (
      !layout.condition ||
      layout.condition(width, height, mode, isPopup, calculateFromFrameSize)
    ) {
      const contentWidth =
        layout.isFullscreen || isFullscreen
          ? width
          : Math.max(width - margins, 0)
      const contentHeight =
        layout.isFullscreen || isFullscreen
          ? height
          : Math.max(height - margins, 0)
      for (let range of layout.sizeRanges) {
        const [minWidth, maxWidth] = range.width
        const [minHeight, maxHeight] = range.height
        if (contentWidth >= minWidth && contentHeight >= minHeight) {
          const layoutWidth = Math.min(contentWidth, maxWidth)
          const layoutHeight = Math.min(contentHeight, maxHeight)
          const area = Math.max(0, layoutWidth) * Math.max(0, layoutHeight)
          if (area > maxArea) {
            maxArea = area
            framedLayout = layout
            framedLayout.isFullscreen =
              framedLayout.isFullscreen || isFullscreen
            framedWidth = layoutWidth
            framedMaxWidth = maxWidth
            framedMaxHeight = maxHeight
            framedHeight = layoutHeight
          }
        }
      }
    }
  }
  return {
    layout: framedLayout,
    width: framedWidth,
    maxWidth: framedMaxWidth,
    height: framedHeight,
    maxHeight: framedMaxHeight,
    portrait: framedMaxHeight > framedMaxWidth
  }
}

function getFramedLayoutTheme(userTheme) {
  const theme = {}
  for (let key in themeDescriptor) {
    const propertyDescriptor = themeDescriptor[key]
    const userValue = userTheme[key]
    if (propertyDescriptor.options) {
      const option = propertyDescriptor.options.find(
        (option) => String(option) === String(userValue)
      )
      theme[key] = option ?? propertyDescriptor.options[0]
    } else {
      theme[key] = userValue ?? propertyDescriptor.default
    }
  }
  return theme
}

export function setFramedLayout(options, calculateFromFrameSize = false) {
  const {
    viewportWidth,
    viewportHeight,
    contentElement,
    containerElement,
    borderElement
  } = options
  const theme = getFramedLayoutTheme(options.theme, calculateFromFrameSize)
  let framedLayout = getLayoutDataForFrame(
    viewportWidth,
    viewportHeight,
    theme.mode,
    calculateFromFrameSize
  )

  setBackgroundColorToContainerElement(
    containerElement,
    framedLayout,
    theme,
    options,
    calculateFromFrameSize
  )
  for (let layout of layouts) {
    for (let aClass of layout.classes) {
      containerElement.classList.remove(aClass)
    }
  }
  for (let aClass of framedLayout.layout.classes) {
    containerElement.classList.add(aClass)
  }
  // Set shadow of unit
  const shadowSize = 30
  if (
    theme.hasShadow &&
    !framedLayout.layout.isShadowHidden &&
    viewportWidth >= framedLayout.width + shadowSize * 2 &&
    viewportHeight >= framedLayout.height + shadowSize * 2
  ) {
    contentElement.style.boxShadow = "0 3px 20px rgba(0, 0, 0, .16)"
  } else {
    contentElement.style.boxShadow = "none"
  }

  //Center layout in frame
  if (responsiveLayouts.includes(framedLayout.layout.name)) {
    contentElement.style.right = 0
    contentElement.style.top = 0
    contentElement.style.width = "100vw"
    contentElement.style.height = "100vh"
  } else {
    contentElement.style.left =
      ((viewportWidth - framedLayout.width) >> 1) + "px"
    contentElement.style.top =
      ((viewportHeight - framedLayout.height) >> 1) + "px"
    contentElement.style.width = framedLayout.width + "px"
    contentElement.style.height = framedLayout.height + "px"
  }
  // Set border of unit
  if (framedLayout.layout.isFullscreen) {
    contentElement.style.borderRadius = "0"
    if (theme.mode === "fullframe") {
      borderElement.style.borderWidth = theme.borderWidth + "px"
      borderElement.style.borderColor = theme.borderColor
    } else {
      borderElement.style.borderWidth = "0"
    }
  } else {
    contentElement.style.borderRadius = theme.borderRadius + "px"
    borderElement.style.borderWidth = theme.borderWidth + "px"
    borderElement.style.borderColor = theme.borderColor
  }
  if (responsiveLayouts.includes(framedLayout.layout.name)) {
    contentElement.style.borderRadius = 0
  }
  framedLayout.theme = theme
  return framedLayout
}

function setBackgroundColorToContainerElement(
  containerElement,
  layoutData,
  theme,
  options,
  calculateFromFrameSize
) {
  if (theme.mode === "popup") {
    if (layoutData.layout && layoutData.layout.isFullscreen) {
      containerElement.style.backgroundColor = "transparent"
    } else {
      if (options.theme.pageLock && !isTransparentBackground()) {
        containerElement.style.backgroundColor = theme.outerBackgroundColor
      } else {
        containerElement.style.backgroundColor = "transparent"
      }
    }
  } else if (theme.mode === "rightTray") {
    if (
      options.theme.pageLock &&
      !calculateFromFrameSize &&
      !isTransparentBackground()
    ) {
      containerElement.style.backgroundColor = theme.outerBackgroundColor
    } else {
      containerElement.style.backgroundColor = "transparent"
    }
  } else if (theme.mode === "fullframe") {
    containerElement.style.backgroundColor = "#fff"
  } else {
    containerElement.style.backgroundColor = "transparent"
  }
}

function isTransparentBackground() {
  return window !== window.top && document.body.id === "oneo-shop"
}
